import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Code, ConnectError } from '@connectrpc/connect';
import { SpecraButton } from '@mono/ui-components';
export function ChatHistoryUnavailable({ error, onRetry }) {
    const inaccessible = error instanceof ConnectError && [
        Code.NotFound,
        Code.PermissionDenied
    ].includes(error.code);
    return /*#__PURE__*/ _jsxs("div", {
        role: "alert",
        className: "p-4 text-sm text-foreground",
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: inaccessible ? 'This conversation is unavailable or you do not have access.' : 'Conversation history could not load. Your saved conversation has not been replaced.'
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "secondary",
                onClick: onRetry,
                children: "Retry loading history"
            })
        ]
    });
}
export function ChatTurnError({ error, onRetry, incomplete = false }) {
    return /*#__PURE__*/ _jsxs("div", {
        role: "alert",
        className: "mt-3 rounded-md border border-border bg-danger-muted p-3 text-sm text-danger",
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: error
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "secondary",
                onClick: onRetry,
                children: incomplete ? 'Continue' : 'Retry response'
            })
        ]
    });
}
